<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <employee-field slot="cc_rep_emname"
          :label="customLabel.cc_rep_emname || '调班对象'"
          v-model="form.main.cc_rep_emname"
          @select="onSelectRepEmployee"
        />
        <datetime-field slot="cc_time" :label="customLabel.cc_time || '调班日期'" v-model="form.main.cc_time" />
        <datetime-field slot="cc_rep_time" :label="customLabel.cc_rep_time || '还班日期'" v-model="form.main.cc_rep_time" />
        <div class="weui-cell" slot="cc_remark">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cc_remark || "调班事由"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cc_remark"
              placeholder="请输入"
            />
          </div>
        </div>
      </custom-layout>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="$router.back()">取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import DatetimeField from "@/components/field/DatetimeField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    EmployeeField,
    DatetimeField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/hr/changeClass",
      codeField: "cc_code",
      statusField: "cc_statuscode",
      caller: "HrChangeClass",
      xtype: 'hr-changeclass-formpanel',
      form: {
        main: {

        }
      }
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main;
      if (!main.cc_rep_emname) {
        me.$weui.topTips("请选择调班对象", 2000);
      } else if (!main.cc_time) {
        me.$weui.topTips("请选择调班日期", 2000);
      } else if (!main.cc_remark) {
        me.$weui.topTips("请填写调班事由", 2000);
      } else {
        me.p_save();
      }
    },
    onSelectRepEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.cc_rep_emname = selection.em_name;
      main.cc_rep_emid = selection.id
      main.cc_rep_emcode = selection.em_code
    }
  }
};
</script>